import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import Invoice from './components/InvoiceTemplate';
import BreadCrumb from '../../shared/components/BreadCrumb';

const InvoiceTemplate = () => (
  <Container>
    <Row>
      <Col md={12}>
        <BreadCrumb title="Order Details"/>
      </Col>
    </Row>
    <Row>
      <Invoice />
    </Row>
  </Container>
);

export default InvoiceTemplate;
